import styled from 'styled-components';
import { Badge } from '@shared/ui/Badge';

const BannerRow = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

/**
 * Показывается в шапке агента когда у пользователя есть can_read=true,
 * но can_write=false (PR #93: cross-agent read-only по матрице ролей).
 * Логику «показывать или нет» определяет вызывающий компонент — здесь
 * только визуальный примитив без props.
 */
export function ReadOnlyBanner() {
  return (
    <BannerRow>
      <Badge $tone="warning">
        Режим просмотра — у вас нет прав на изменение в этом разделе
      </Badge>
    </BannerRow>
  );
}
